import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common';
import { closeModal } from '../../modals/framework/store/modal-actions';

export const discardPostSettings = () =>
  closeModal({ type: MODAL_TYPE_POST_SETTINGS });
